module.exports = __webpack_public_path__ + "img/03_Gruende_iPad_P.af2976b6.jpg";